var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryTruck1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3429_20521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37378 5.22656C6.17048 5.22656 5.97562 5.30728 5.83186 5.451C5.68814 5.59472 5.60742 5.78962 5.60742 5.99292V12.2179H15.7618V5.22703L6.37378 5.22656Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8156 10.5239L20.4628 6.61327C20.3172 6.44344 20.1046 6.3457 19.8809 6.3457L17.2945 6.34589V12.9857C17.2945 13.409 16.9514 13.7521 16.5282 13.7521H5.60742V16.0512C5.60742 16.4744 5.9505 16.8175 6.37378 16.8175H8.60784C8.93963 17.9465 9.98447 18.7733 11.2195 18.7733C12.4545 18.7733 13.4992 17.9465 13.8311 16.8175H15.8723C16.2041 17.9465 17.249 18.7733 18.484 18.7733C19.719 18.7733 20.7637 17.9465 21.0956 16.8175H23.2339C23.6571 16.8175 24.0002 16.4744 24.0002 16.0512V11.0227C24.0002 10.8397 23.9347 10.6628 23.8156 10.5239ZM11.2195 17.2406C10.5636 17.2406 10.03 16.7071 10.03 16.0513C10.03 15.3953 10.5636 14.8617 11.2195 14.8617C11.8753 14.8617 12.4089 15.3953 12.4089 16.0513C12.4089 16.7071 11.8753 17.2406 11.2195 17.2406ZM19.6734 16.0519C19.673 16.7075 19.1396 17.2407 18.484 17.2407C17.8281 17.2407 17.2945 16.7071 17.2945 16.0513C17.2945 15.3954 17.8281 14.8618 18.484 14.8618C19.1396 14.8618 19.673 15.3951 19.6734 16.0506C19.6734 16.0508 19.6733 16.051 19.6733 16.0512C19.6733 16.0515 19.6734 16.0516 19.6734 16.0519Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.766453 10.2559C0.343266 10.2558 0 10.599 0 11.0222C9.375e-05 11.4454 0.343172 11.7886 0.766359 11.7886L4.07442 11.7886V10.2559L0.766453 10.2559Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07447 7.18945H3.32105C2.89786 7.1895 2.55469 7.53258 2.55469 7.95577C2.55469 8.37905 2.89786 8.72217 3.32105 8.72217H4.07452L4.07447 7.18945Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07477 13.3223H2.29956C1.87637 13.3223 1.5332 13.6653 1.5332 14.0886C1.5332 14.5118 1.87637 14.8549 2.29956 14.8549H4.07486L4.07477 13.3223Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3429_20521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck1);
export default __webpack_public_path__ + "static/media/delivery-truck 1.500eb999509cf0426665a3f2e6173b1f.svg";
export { ForwardRef as ReactComponent };